<template>
  <div>
    <el-row class="parent">
      <el-col :span="24" class="toolbar formbg" style="padding-bottom: 0px">
        <el-form ref="searchForm" :inline="true" label-width="110px" :model="searchForm" :rules="rules" class="form-search inputStyle">
          <el-form-item label="收款方名称：" prop="accountName">
            <el-input v-model="searchForm.accountName" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item label="收款账号：" prop="accountNo">
            <el-input v-model="searchForm.accountNo" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item label="审核状态：" prop="status">
            <el-select v-model="searchForm.status" filterable placeholder="全部"  clearable>
              <el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="常驻国家：" prop="countryName">
            <el-select v-model="searchForm.countryName" filterable placeholder="全部" @change="getCountryValue($event)" clearable>
              <el-option v-for="item in countryOptions" :key="item.paramKey" :label="item.paramValue" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="创建日期：" prop="createTime">
            <el-date-picker
              style="width: 270px"
              clearable
              v-model="searchForm.createTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="daterange"
              range-separator="~"
              start-placeholder="起始日期"
              end-placeholder="结束日期"
            />
          </el-form-item>
          <el-form-item label="操作：" class="operateStyle">
            <el-button type="primary" size="medium" :loading="listLoading" @click="getData">查询</el-button>
            <el-button size="medium" @click="resetSearchForm">重置</el-button>
            <el-button type="primary" size="medium" @click="openPayeeDialog('add')">新增</el-button>
          </el-form-item>
        </el-form>

      </el-col>
      
      <el-table ref="multipleTable" :key="tableKey" v-loading="listLoading" :data="tableData" border fit highlight-current-row style="width: 100%">
        <el-table-column label="金控收款人编号" align="center" prop="payeeNo" width="150px" />
        <el-table-column label="收款方名称" align="center" prop="accountName" width="150px" />
        <el-table-column label="收款账号" align="center" prop="accountNo" width="150px" />
        <el-table-column label="收款人常驻国家" align="center" prop="countryName" width="150px" />
        <el-table-column label="常用结算币种" align="center" prop="settlementCurrencyName" width="150px" />
        <el-table-column label="创建日期" align="center" prop="createTime" width="160px" />
        <el-table-column label="审核状态" align="status" width="150px">
          <template slot-scope="scope">
            <span v-if="scope.row.status === '0'">审核中</span>
            <span v-else-if="scope.row.status === '1'">审核成功</span>
            <span v-else-if="scope.row.status === '2'">审核拒绝</span>
          </template>
        </el-table-column>
        <el-table-column label="拒绝原因" align="center" prop="reason" width="150px" />
        <el-table-column label="操作" align="center" width="200px">
          <template slot-scope="scope">
            <!-- <el-button @click="handleQuery(scope.row)">详情</el-button> -->
            <!-- <el-button v-if="scope.row.status==='2'" @click="handleUpdate(scope.row)">修改</el-button> -->
            <el-button type="text" @click="openPayeeDialog('lookup', scope.row.payeeNo)">详情</el-button>
            <el-button type="text" v-if="scope.row.status === '2'" @click="openPayeeDialog('update', scope.row.payeeNo)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--分页工具条-->
      <pagination style="margin-top:20px;" v-show="total > 0" :total="total" :page.sync="page" :limit.sync="size" :current-page="page" @pagination="getDataByPage" />
    </el-row>

    <!-- 付款人对话框 -->
    <payee-dialog ref="payeeDialog" @query="getData" />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination/index' // 分页
import { querySetInfoPage, confirmInfo, queryItemCode, insertData, updateData } from '@/api/crossborder/collection/abroadCollection'
import Common from '@/utils/common' // 工具类
import payeeDialog from './payeeDialog.vue'
export default {
  name: 'SetOrderSearch',
  components: {
    Pagination,
    payeeDialog,
  },
  filters: {},
  data() {
    return {
      tableKey: 0,
      rules: {},
      searchForm: {
        merNo: null,
        payeeNo: null,
        accountName: null,
        accountNo: null,
        status: null,
        countryCode: null,
        createTime: null,
      },
      searchFormRules: {
        createTime: [{ required: true, message: '请选择日期', trigger: 'blur' }],
      },
      detailList: [], // 页面列表
      addDetailFormVisible: false,
      updateDetailFormVisible: false,
      queryDetailFormVisible: false,
      total: 0, // 分页总条数
      page: 1, // 分页页码
      size: 10, // 分条数
      // 表格显示加载中
      listLoading: false,
      tableData: [],

      status: [
        {value: '0', label: '审核中'},
        {value: '1', label: '审核成功'},
        {value: '2', label: '审核拒绝'},
      ],

      countryOptions: [],
    }
  },
  beforeMount() {
    this.name = this.$route.meta.title
  },
  mounted() {
    this.getCountryAreaCode()
  },
  methods: {

    // 选择国家的时候，获取countryCode
    getCountryValue(country) {
      this.searchForm.countryCode = country.paramKey
      this.searchForm.countryName = country.paramValue
    },

    // 获取国家列表
    getCountryAreaCode() {
      const param = {
        itemCode: 'country-area-code',
        size: 300,
      }
      queryItemCode(param)
        .then((res) => {
          this.countryOptions = res.data
        })
        .catch((error) => {
          //  this.$message.error(error)
          console.log(error)
        })
    },

    // 重置按钮
    resetSearchForm() {
      this.searchForm = {
        merNo: null,
        payeeNo: null,
        accountName: null,
        accountNo: null,
        status: null,
        countryCode: null,
        createTime: null,
      }
    },

    // 查询
    getData() {
      this.page = 1
      this.getDataByPage() 
    },

    // 查询列表
    getDataByPage() {

      const param = Common.setNull({
        page: this.page,
        size: this.size,
        merNo: this.$store.getters.merNo,
        accountName: this.searchForm.accountName,
        accountNo: this.searchForm.accountNo,
        status: this.searchForm.status,
        countryCode: this.searchForm.countryCode,
        startTime: this.searchForm.createTime ? this.searchForm.createTime[0] : null,
        endTime: this.searchForm.createTime ? this.searchForm.createTime[1] : null,
      })
      this.tableData = []
      this.listLoading = true
      querySetInfoPage(param)
        .then((response) => {
          this.listLoading = false
          if(response.data.list) this.tableData = response.data.list
          this.total = response.data.total
          this.page = response.data.page
          this.size = response.data.size
        })
        .catch((err) => {
          this.listLoading = false
          console.log(err)
        })
    },

    openPayeeDialog(type, payeeNo) {
      this.$refs.payeeDialog.open(type, payeeNo)
    },
  },
}
</script>
<style lang='scss' scoped>
@import '@/styles/common.scss';
::v-deep .inputStyle .el-form-item__content {
  width: 270px;
}
::v-deep .operateStyle .el-form-item__content {
  width: 500px;
}
</style>
